export const scrollTo = (selector = '.scroll_container') => {
	document?.querySelector(selector)?.scrollTo(0, 0);
};
